<template>
  <span v-if="active" class="sort-arrow">
    {{ asc ? '▲' : '▼' }}
  </span>
</template>

<script>
export default {
  name: 'SortArrow',
  props: {
    active: Boolean,
    asc: Boolean,
  },
};
</script>

<style scoped>
.sort-arrow {
  margin-left: 5px;
  font-size: 0.7em;
}
</style>